import Layout from '@/views/layout'
import i18n from '@/lang'
import { getUserLanguage } from '@/utils/auth'
i18n.locale = getUserLanguage()

export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index'),
    meta: { title: 'login' },
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    meta: { title: 'error' },
    hidden: true
  },
  {
    path: '/500',
    component: () => import('@/views/errorPage/500.vue'),
    hidden: true
  },
  {
    path: '/toyotaAgreement',
    component: () => import('@/views/toyotaAgreement/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: 'home',
    menuName: i18n.t('navbar.dashboard'),
    children: [
      {
        path: '/home',
        onlyChild: true,
        component: () => import('@/views/home/index'),
        name: 'home',
        menuName: i18n.t('navbar.dashboard'),
        meta: { title: 'home', icon: 'icon_home', iconType: 'svg' }
      }
    ]
  }
]
